module.exports = __webpack_public_path__ + "img/american_football.fd7946b.png";